import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { Client } from '../../../types';
import EditClientForm from './EditClientForm';

interface EditClientDialogProps {
  open: boolean;
  onClose: () => void;
  client: Client;
  onClientUpdated: (client: Client) => void;
}

const EditClientDialog: React.FC<EditClientDialogProps> = ({
  open,
  onClose,
  client,
  onClientUpdated,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Edit Client
        <IconButton
          onClick={onClose}
          aria-label="Close"
          size="small"
          sx={{ position: 'absolute', right: 12, top: 12, color: 'text.secondary' }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <EditClientForm
          client={client}
          onCancel={onClose}
          onSuccess={(updatedClient) => {
            onClientUpdated(updatedClient);
            onClose();
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default EditClientDialog;
